<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="所属仓库" prop="warehouseName">
              {{ formData.warehouseName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygType" label="类型">
              {{ formData.ygType === 'B' ? '入库' : '出库' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出入库类型" prop="recType">
              {{ cyRecTypeMap.get(formData.recType) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品种规格" prop="specName">
              {{ formData.specName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属客户" prop="userName">
              {{ formData.userName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量" prop="recQuantity">
              {{ formData.recQuantity }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="记录时间" prop="ctime">
              {{ formData.ctime }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="记录来源" prop="sourceType">
              {{ recordSourceTypeMap.get(formData.sourceType) }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="关联订单" prop="">
              <el-table size="mini" stripe border v-loading="loading" :data="tableData">
                <el-table-column show-overflow-tooltip min-width="100" label="提货ID" prop="deliveryId"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" label="订单ID" prop="orderId"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" label="合同标题" prop="orderTitle"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" label="合同编号" prop="orderNum"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" label="供应商"
                  prop="supplierName"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" label="发货状态" prop="deliveryState">
                  <template v-slot="{ row }">
                    {{ deliveryStateMap.get(row.deliveryState) }}
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="140" label="提货日期"
                  prop="deliveryDate"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="140" label="创建时间" prop="ctime"></el-table-column>
              </el-table>

              <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                @current-change="loadData">
              </el-pagination>
            </el-form-item>
          </el-col> -->
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { cyRecType, recordSourceType, deliveryState } from '@/utils/dict'
export default {
  name: 'InventoryFlowDetail',
  data() {
    return {
      cyRecTypeMap: cyRecType,
      recordSourceTypeMap: recordSourceType,
      deliveryStateMap: deliveryState,
      page: 1,
      total: 0,
      tableData: [],
      formData: {
        id: '', // 主键
        warehouseId: '', // 仓库id
        ygType: '', // 类型A出库B入库
        recType: '', // 出入库类型B1采购入库B2生产入库B3调拨入库B4租赁入库A1销售出库A2生产消耗A3调拨出库A4租赁出库
        specId: '', // 规格id
        userId: '', // 所属客户id
        objId: '', // 关联id(对应的提货单,生产单等)
        recQuantity: '', // 数量
        createUserId: '', // 操作人
        ctime: '', // 操作时间
        objNum: '', // 关联单号
        sourceType: '', // 记录来源 TH云销提货单YC云采CY储运 SC生产
        byzdA3: '', // 备用字段3
        byzdA4: '', // 备用字段4
        byzdA5: '', // 备用字段5
        byzdA6: '' // 备用字段6
      }
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  created() {
    this.loadDetails()
  },
  methods: {
    loadDetails() {
      this.$axios.get(this.$apis.prodManage.selectLyWareRecById, {
        params: { id: this.id }
      }).then(res => {
        this.formData = res
      })
    },
    loadData() {}
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
